export const SET_LOYALTY = "SET_LOYALTY";
export const SET_LOYALTY_CLIENT = "SET_LOYALTY_CLIENT";
export const SET_LOYALTY_CLIENT_TRANSACTIONS = "SET_LOYALTY_CLIENT_TRANSACTIONS";
export const SET_LOYALTY_SEGMENTATION_CONFIG = "SET_LOYALTY_SEGMENTATION_CONFIG";
export const SET_LOYALTY_SEGMENTATION = "SET_LOYALTY_SEGMENTATION";
